<template>
  <div >
      <div class="search_location">
        <input type="text" :placeholder="lang.curlang[0]" :value="address">
        
        
        <v-btn 
          :disabled="dialog"
          :loading="dialog"
          @click="onLocationClick"
        > </v-btn>
      </div>
      <devicemap ref="wifimap" class="wifimapcss"/>
  </div>
</template>

<script>
// @ is an alias to /src
import devicemap from '@/components/DeviceMap.vue'

export default {
  components: {
    devicemap
  },
  methods: {
    onLocationClick() {
      var that=this;
        if (navigator.geolocation) {
          that.dialog=true;

          let currentObj = this;
          let axios=this.$axios;


          navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };

            let rGeoAPI="https://maps.googleapis.com/maps/api/geocode/json?latlng="+ pos.lat + "," +  pos.lng + "&key=AIzaSyDSnn4PLwW7kMPBmXkOrcLXrA4Gd-31VRU";
            if (currentObj.$route.query.lang=="en") {
              rGeoAPI += "&language=en"
            }
            axios.get(rGeoAPI)
              .then(function(response) {
                console.log(response.data.results[0].formatted_address);
                currentObj.address=response.data.results[0].formatted_address;
                that.dialog=false;

                console.log(pos.lat, pos.lng)
                that.$refs.wifimap.initializeUserMarker(pos)

                //that.$refs.wifimap.setMapCenter(pos)
              })
              .catch(function(error) {
                that.dialog=false;
                console.log(error);
              })
          }, function(error) {
            console.log("getCurrentPosition failure");
            that.dialog=false;
            that.lang.curlang[0]=error.message;
          });
        } else {
          console.log("no navigator.geolocation");
          that.lang.curlang[0]="no novagator.geolocation";
          that.dialog=false;
        }
    }
  },

    data () {
      return {
        address: "",
        loading: true,
        dialog: false,
        isLangEn: false,
        lang: {
          curlang: [],
          en: [
            'Turn on positioning permission',
            'Locating your address'
          ],
          zhtw: [
            '開啟定位查詢您的位置,點擊右方按鈕定位所在位置',
            '正在定位您的所在位置'
          ],
          zhcn: [
            '开启定位查询您的位置,点击右方按钮定位所在位置',
            '正在定位您的所在位置'
          ],
          jp: [
            '位置情報サービスをオンにして、現在地を検索してください。右側のボタンを押すと現在地を特定できます',
            '現在地の特定'
          ],
          kr: [
            '위치 검색을 열고 오른쪽 버튼을 클릭하여 위치를 찾습니다',
            '위치 찾기 시작'
          ]
        }
      }
    },
    
    mounted() {
      if (this.$route.query.lang=="en") {
        this.lang.curlang=this.lang.en;
      }
      else if (this.$route.query.lang=="kr") {
        this.lang.curlang=this.lang.kr;
      }
      else if (this.$route.query.lang=="jp") {
        this.lang.curlang=this.lang.jp;
      }
      else if (this.$route.query.lang=="zh-cn") {
        this.lang.curlang=this.lang.zhcn;
      }
      else {
        this.lang.curlang=this.lang.zhtw;
      }
    }
}
</script>


<style scoped>
.wifimapcss {
  height: 600px;
}
/*
@import 'https://tt-free.taitung.gov.tw/wp-includes/css/dist/block-library/style.min.css';
@import 'https://tt-free.taitung.gov.tw/wp-content/themes/zita/style.css';
@import 'https://tt-free.taitung.gov.tw/wp-content/themes/TTFree/style.css';
@import 'https://tt-free.taitung.gov.tw/wp-content/themes/TTFree/custom.css';
*/

@import 'https://app.quickclick.cc/charity-food/custom/css/style.min.css';
@import 'https://app.quickclick.cc/charity-food/custom/css/style-zita.css';
@import 'https://app.quickclick.cc/charity-food/custom/css/style.css';
@import 'https://app.quickclick.cc/charity-food/custom/css/custom.css';

</style>